/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExerciseIntervalDto
 */
export interface ExerciseIntervalDto {
    /**
     * 
     * @type {number}
     * @memberof ExerciseIntervalDto
     */
    durationSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof ExerciseIntervalDto
     */
    pauseAfterSeconds?: number;
}

/**
 * Check if a given object implements the ExerciseIntervalDto interface.
 */
export function instanceOfExerciseIntervalDto(value: object): value is ExerciseIntervalDto {
    if (!('durationSeconds' in value) || value['durationSeconds'] === undefined) return false;
    return true;
}

export function ExerciseIntervalDtoFromJSON(json: any): ExerciseIntervalDto {
    return ExerciseIntervalDtoFromJSONTyped(json, false);
}

export function ExerciseIntervalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExerciseIntervalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'durationSeconds': json['durationSeconds'],
        'pauseAfterSeconds': json['pauseAfterSeconds'] == null ? undefined : json['pauseAfterSeconds'],
    };
}

export function ExerciseIntervalDtoToJSON(json: any): ExerciseIntervalDto {
    return ExerciseIntervalDtoToJSONTyped(json, false);
}

export function ExerciseIntervalDtoToJSONTyped(value?: ExerciseIntervalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'durationSeconds': value['durationSeconds'],
        'pauseAfterSeconds': value['pauseAfterSeconds'],
    };
}

